import { useEffect } from 'react';
import { FaHome, FaAngleDoubleLeft, FaAngleLeft, FaAngleRight, FaAngleDoubleRight } from 'react-icons/fa';
import $ from 'jquery';
import styled from 'styled-components';

const TableComp = ({ className, tablesorter }) => {
	useEffect(() => {
		$('#myTable')
			.tablesorter({
				theme: 'ice',
				widgets: ['filter', 'zebra', 'cssStickyHeaders', 'pager'],
				widgetOptions: { cssStickyHeaders_attachTo: '.table-container', uitheme: 'jui' },
			})
			.tablesorterPager({
				// target the pager markup - see the HTML block below
				container: $('.pager'),

				// output string - default is '{page}/{totalPages}';
				// possible variables:
				// {page}, {totalPages}, {startRow}, {endRow} and {totalRows}
				output: '{page}/{totalPages} ({startRow}-{endRow})',

				// apply disabled classname to the pager arrows when the rows at
				// either extreme is visible - default is true
				updateArrows: true,

				// starting page of the pager (zero based index)
				page: 0,

				// Number of visible rows - default is 10
				size: 12,

				// if true, the table will remain the same height no matter how many
				// records are displayed. The space is made up by an empty
				// table row set to a height to compensate; default is false
				fixedHeight: true,

				// remove rows from the table to speed up the sort of large tables.
				// setting this to false, only hides the non-visible rows; needed
				// if you plan to add/remove rows with the pager enabled.
				removeRows: false,

				// css class names of pager arrows
				// next page arrow
				cssNext: '.next',
				// previous page arrow
				cssPrev: '.prev',
				// go to first page arrow
				cssFirst: '.first',
				// go to last page arrow
				cssLast: '.last',
				// select dropdown to allow choosing a page
				cssGoto: '.gotoPage',
				// location of where the "output" is displayed
				cssPageDisplay: '.pagedisplay',
				// dropdown that sets the "size" option
				cssPageSize: '.pagesize',
				// class added to arrows when at the extremes
				// (i.e. prev/first arrows are "disabled" when on the first page)
				// Note there is no period "." in front of this class name
				cssDisabled: 'disabled',
			});
	});
	let classes = { className };
	if (tablesorter) {
		classes += 'tablesorter';
	}

	return (
		<table id="myTable" class={classes} style={{ width: '100%' }}>
			<thead>
				<tr>
					<th>Task</th>
					<th>Daily</th>
					<th>Weekly</th>
					<th>Monthly</th>
					<th>Quarterly</th>
					<th>Biannually</th>
					<th>Annually</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Verify all covers and doors are closed and secure. Guards, shields, and other mechanical safety devices: Ensure all safety devices are properly installed and fully functional.</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>

				<tr>
					<td>Check all limit switches for looseness, wear or malfunction.</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Check all hoses, piping, cylinders, valves, fittings, mufflers, and gauges for damage, wear or leaks.</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Loose bolts: Ensure that all bolts are tightened to specifications.</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Bearings, couplings: Check for excessive wear, noise, heat, vibration, binding or out of position. Grease and lubricate as specified in this manual.</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Check all rough locators and locating pins for wear or damage. Look for loose bolts, missing shims, and bent or distorted details. Verify that all part locators are in correct alignment and that the parts are being located correctly.</td>
					<td>-</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Shot pins: Inspect for wear and replace if needed</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Rest pads: check rest pads for wear, loose bolts and fasteners, make sure that they make even contact on the body surfaces. Clean blocks of debris and other foreign parts.</td>
					<td>-</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Part clamping fixtures: Verify clamping fixture is clear of debris and slag. Verify that all part clamping units are in correct alignment and that the parts are being clamped correctly.</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Clamping parts: check for loose or missing shims on clamping details, check side plates for loose fasteners, wear and cracks. Check clamps for alignment side play and bushing wear</td>
					<td>-</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Check metal (part) clearance to clamps and adjust as required. Check clamping cycles for timing with metal in fixture.</td>
					<td>-</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
				<tr>
					<td>Mechanical safety devices: Inspect and make sure all safety devices are properly installed and fully operational.</td>
					<td>-</td>
					<td>-</td>
					<td>X</td>
					<td>-</td>
					<td>-</td>
					<td>-</td>
				</tr>
			</tbody>
			<tfooter id="pager" className="pager" style={{}}>
				<form>
					<FaAngleDoubleLeft size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="first" alt="button" />
					<FaAngleLeft size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="prev" alt="button" />
					<input type="text" className="pagedisplay" alt="button" />
					<FaAngleRight size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="next" alt="button" />
					<FaAngleDoubleRight size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="last" alt="button" />
					<select className="pagesize">
						<option selected="selected" value="12">
							12
						</option>
					</select>
				</form>
			</tfooter>
		</table>
	);
};

const MaintenanceTable = styled(TableComp)``;

export default MaintenanceTable;
